import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavigationContainer = styled.div`
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center; /* Center content vertically */
  justify-content: space-between; /* Spread content horizontally */

  @media (max-width: 768px) {
    flex-direction: column; /* Change to column layout on small screens */
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    margin-bottom: 50px;
  }
`;

export const LogoContainer = styled(Link)`
  height: 100%;
  width: 70px;
  padding: 20px; /* Reduce padding on small screens */
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 10px; /* Add a small margin between logo and links */
  }
`;

export const NavLink = styled(Link)`
  padding: 10px 15px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin: 5px 0; /* Add spacing between links on small screens */
  }
`;
